/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_NameInputs */

const en_directory_submit_name = /** @type {(inputs: Directory_Submit_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool name`)
};

const zh_directory_submit_name = /** @type {(inputs: Directory_Submit_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具名称`)
};

/**
* | output |
* | --- |
* | "Tool name" |
*
* @param {Directory_Submit_NameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_name = /** @type {((inputs?: Directory_Submit_NameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_NameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_name(inputs)
	return zh_directory_submit_name(inputs)
});
export { directory_submit_name as "directory.submit.name" }